import { useRouteLoaderDataTyped } from "infrastructure/router";
import { ApiRouteTypes } from "consts/enpoints/api";
import type { ResourceResponse } from "types";

export const useSettings = <T extends unknown>() => {
    const response = useRouteLoaderDataTyped<ResourceResponse<T>>(ApiRouteTypes.GetSettings);

    const getSettings = (fallback = {} as T) => response.data ?? fallback;

    return {
        getSettings
    };
};

export default useSettings;
